/**
 * Calm Command — shared canvas / gameplay constants.
 *
 * Extracted from CalmCommand.jsx to keep the game component focused on React
 * lifecycle + input handling. Pure module — safe to import from anywhere and
 * from unit tests.
 */
export const TAU = Math.PI * 2;

/** Vertical position (as a fraction of canvas height) of the anchor row. */
export const ANCHOR_Y_FRAC = 0.88;
/** Anchor hit radius (px). */
export const ANCHOR_RADIUS = 16;
/** Vertical position of the horizon line (where background art meets ground). */
export const HORIZON_Y_FRAC = 0.82;

export const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
export const rand = (a, b) => a + Math.random() * (b - a);

/** Format a positive seconds count as "M:SS". */
export const formatMMSS = (secs) => {
  const s = Math.max(0, Math.round(secs));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${r.toString().padStart(2, '0')}`;
};

/**
 * Deterministic PRNG (mulberry32). Same seed → same sequence.
 * Used by `buildScene` and `buildWeather` so each biome renders the same
 * silhouette across runs.
 */
export function seededRng(seed) {
  let a = seed >>> 0;
  return () => {
    a |= 0; a = (a + 0x6D2B79F5) | 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
